import React, { useContext } from "react";

import styled from "styled-components";

import PaymentDetailsComponent from './PaymentDetailsComponent';

import { logout} from '../../utils/loginHelper';
import {UserContext} from '../../utils/userDetailsProvider';
import {PaymentContext} from '../../utils/paymentConfigProvider';

//import './accordion.css';
//import 'react-accessible-accordion/dist/fancy-example.css';
import userProfile from '../../assets/user_circle_outline.svg';
import userSignOut from '../../assets/door_arrow_right_outline.svg';
import WallFlower from '../../assets/begonia.jpg';


const Container = styled.div`
  width: 335px;
  right: 72px;
  top: 60.5px;
  position: fixed;
  display: flex;
  background: #0F0F0F;
  box-shadow: 0px 4px 60px #000000;
  padding: 24px;
  display: ${props => props.open ? "block" : "none"};
  z-index: 2;
`;

const Text = styled.a`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #FFFFFF;
  margin-left: 13px;
`;

const TextSpan = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #FFFFFF;
  margin-left: 13px;
`;

const HeaderSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`

export default function ProfileDropdown({
    open, user, openAddPaymentsDiv, setAddSocialModalOpen}){

    const paymentConfig = useContext(PaymentContext);
    let isIndiaPayment = false;
    if(paymentConfig && paymentConfig.acceptedGateways){
        isIndiaPayment = (
            (paymentConfig.acceptedGateways.includes('razorpay'))?true:false);
    }

    console.log('container', open)
    
    return (
	<Container open={open}>
	    <div><HeaderSpan>{user.username}</HeaderSpan></div>
            <div style={{
	        display: "flex",
                marginTop:isIndiaPayment ? 18:0,
	    }}>
	    </div>
            {(isIndiaPayment) && (<></>)}
            {(!isIndiaPayment) && (
                <PaymentDetailsComponent
                    openAddPaymentsDiv={openAddPaymentsDiv}
                >
                </PaymentDetailsComponent>
            )}
	    <div>
	        <div style={{
                    marginTop:24,
		    borderTop: '1px solid rgba(255,255,255,0.1)'
	        }}>
		    <div>
			<div style={{
			    display: 'flex',
			    justifyContent: 'flex-start',
			    marginTop: 25, marginBottom: 25
			}}
			>
			    <img src={userProfile}  />
			    <Text
                                href={`/address/${user.username}`}
                                onClick={() => {
                                    window.analytics.track('mynfts_clicked', {
                                        type: 'web',
                                        from: 'Profile-dropdown'
                                    });
                                }}
                            >
                                My Profile
                            </Text>
			</div>
                        <div
                            onClick={()=>{setAddSocialModalOpen(true)} }
                            style={{
			        display: 'flex',
			        justifyContent: 'flex-start',
			        marginTop: 25, marginBottom: 25,
                                cursor:'pointer'
			    }}
			>
			    <img style={{width:24,
                                         height:24,
                                         borderRadius:24,
                                         objectFit:'scale-down'
                            }} src={WallFlower}  />
			    <TextSpan>
                                Claim Perks
                            </TextSpan>
			</div>
			<div style={{
			    display: 'flex',
			    justifyContent: 'flex-start',
			    marginTop: 25, marginBottom: 25,
                            cursor:'pointer'
			}}
                             onClick={()=>{logout()}}
                        >
			    <img src={userSignOut} />
			    <Text>Sign out</Text>
			</div>
		    </div>
		</div>
	    </div>
	</Container>
    );
};
